import { render, staticRenderFns } from "./branch.vue?vue&type=template&id=b28fb640&scoped=true&lang=pug&"
import script from "./branch.vue?vue&type=script&lang=js&"
export * from "./branch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28fb640",
  null
  
)

export default component.exports